import axios from 'axios'
import { createWithEqualityFn } from 'zustand/traditional'

interface BillingTransactionStore {
	data: any[]
	setData: (data: any[]) => void
	getAll: () => Promise<{ success: boolean; data: any }>
	clearState: () => void
}

export const API_SLUG = 'suppliers/transactions'

export const useBillingTransactionStore = createWithEqualityFn<BillingTransactionStore>(
	set => ({
		data: [],
		setData: (data: any[]) => set({ data }),
		getAll: async () => {
			return axios
				.get(`/${API_SLUG}`)
				.then(res => {
					set({ data: res.data })
					return { success: true, data: res.data }
				})
				.catch(err => {
					return {
						success: false,
						data: err?.response?.data?.message?.toString() || 'An error occurred',
					}
				})
		},
		clearState: () => set({ data: [] }),
	}),
	Object.is
)
